import { Plus } from 'lucide-react'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/Tooltip'

// GitHub's "+" at the left edge of a row: hidden until the row is hovered
// (the row carries the `group` class), opens or jumps to the row's comment
// composer. Kept as a plain button on purpose — it sits inside a table cell
// at 18px, like the collapse toggle in ChannelMatrixRow.
export default function RowCommentButton({ onClick, label }: { onClick: () => void; label: string }) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <button
          type="button"
          aria-label={`Comment on ${label}`}
          onClick={(e) => { e.stopPropagation(); onClick() }}
          className="absolute left-1 top-1/2 -translate-y-1/2 inline-flex h-[18px] w-[18px] items-center justify-center rounded-sm bg-primary text-primary-foreground opacity-0 transition-opacity group-hover:opacity-100 focus-visible:opacity-100 focus-visible:outline-none"
        >
          <Plus size={12} strokeWidth={2.5} />
        </button>
      </TooltipTrigger>
      <TooltipContent>Add a comment</TooltipContent>
    </Tooltip>
  )
}
